var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Page',{attrs:{"total":_vm.total,"page-size-opts":_vm.pageSizeOpts,"page-size":_vm.pageSize,"current":_vm.current,"show-total":"","show-sizer":"","show-elevator":""},on:{"on-change":_vm.changePage,"on-page-size-change":_vm.changePageSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }